import { Tag } from "@brg/api";
import { FlexBox, HintTooltip, useIsMobile } from "@brg/ui";
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import SortableList, { SortableItem, SortableKnob } from "react-easy-sort";
import { arrayMoveImmutable } from "shared/utils/arrayMove";
import { IConvertedTags } from "./DroppableCategoryList";
import { DropDownWrapper, DroppableChildrenTitle } from "./styles";
import { useSelector } from "react-redux";
import { TagAdminSelector } from "shared/reducers/tagAdminSlice";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CreateLinkTo } from "shared/constants/linkTo";
import { TAG_ADMIN_OPERATION } from "_deziiign/main/pages/MainTagAdminPage/MainTagAdminPage";
import { CategoryWrapper } from "../../styles";
import { DottedIcon } from "shared/icons/DottedIcon";

export const DroppableItem: FC<{ 
    tag: Tag<'Local'>, 
    isChild?: boolean,
    hasChild?: boolean,
    isActive?: boolean, 
    isTablet?: boolean,
    isEditTag?: boolean,
    onClick: (ev: any, tag: Tag) => void;
}> = ({ 
    tag, 
    isChild,
    hasChild,
    isActive,
    isTablet, 
    isEditTag,
    onClick,
}) => {
    const { t } = useTranslation();

    return (
        <CategoryWrapper 
            onClick={(ev: any) => onClick(ev, tag)} 
            gx={16} 
            justify="space-between"
            align="center" 
            data-id={tag?.tagId} 
            isChild={isChild} 
            isActive={isActive}
        >
            <FlexBox align={'center'} alignMobile="center">
                {isActive ? (
                    <HintTooltip customStyle={{ background: '#fff', color: '#151514'}} text={'Закройте категория для перетаскивания'} noDisappearDelay onWhiteBg>
                        <div style={{ marginLeft: isTablet ? (isChild ? 24 : 0) : (isChild ? 48 : 0) , backgroundColor: 'transparent' }}>
                            <DottedIcon/>
                        </div>
                    </HintTooltip>
                ) : (
                    <SortableKnob>
                        <div style={{ marginLeft: isTablet ? (isChild ? 24 : 0) : (isChild ? 48 : 0) , cursor: 'grab', backgroundColor: 'transparent' }}>
                            <DottedIcon/>
                        </div>
                    </SortableKnob>
                )}
                <DroppableChildrenTitle 
                    isChild={isChild}
                    data-type={'location'}
                    isEditTag={isEditTag}
                >
                    {tag?.name}
                </DroppableChildrenTitle>
            </FlexBox>

            <FlexBox align="center" justify="flex-end" gx={40} direction="row">
                {hasChild && (
                    <FlexBox data-type={'dropdown'}>
                        <svg data-type={'dropdown'} className={'shevron-icon'} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path data-type={'dropdown'} d="M12 9.90997L18.8882 17.0314C19.2341 17.389 19.7948 17.389 20.1406 17.0314C20.4865 16.6739 20.4865 16.0941 20.1406 15.7366L12.6262 7.96775C12.2804 7.6102 11.7197 7.6102 11.3738 7.96775L3.85941 15.7366C3.51357 16.0941 3.51356 16.6739 3.8594 17.0314C4.20524 17.389 4.76596 17.389 5.1118 17.0314L12 9.90997Z" fill="#909090"/>
                        </svg>
                    </FlexBox>
                )}
                <div data-type={'remove'}>
                    <HintTooltip data-type={'remove'} customStyle={{ background: '#fff', color: '#151514'}} textOffset={'-170px'} text={t("hints.delete_category")} z={6} noDisappearDelay onWhiteBg>
                        <svg data-type={'remove'} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path data-type={'remove'} fillRule="evenodd" clipRule="evenodd" d="M9.42676 2.46289C8.59833 2.46289 7.92676 3.13446 7.92676 3.96289V4.46289H4.42676C3.59833 4.46289 2.92676 5.13446 2.92676 5.96289V6.96289C2.92676 7.79132 3.59833 8.46289 4.42676 8.46289H4.92676V20.9629C4.92676 21.7913 5.59833 22.4629 6.42676 22.4629H17.4268C18.2552 22.4629 18.9268 21.7913 18.9268 20.9629V8.46289H19.4268C20.2552 8.46289 20.9268 7.79132 20.9268 6.96289V5.96289C20.9268 5.13446 20.2552 4.46289 19.4268 4.46289H15.9268V3.96289C15.9268 3.13446 15.2552 2.46289 14.4268 2.46289H9.42676ZM14.9268 4.46289V3.96289C14.9268 3.68675 14.7029 3.46289 14.4268 3.46289H9.42676C9.15062 3.46289 8.92676 3.68675 8.92676 3.96289V4.46289H14.9268ZM7.92676 5.46289H4.42676C4.15062 5.46289 3.92676 5.68675 3.92676 5.96289V6.96289C3.92676 7.23903 4.15062 7.46289 4.42676 7.46289H4.92676H5.42676H18.4268H18.9268H19.4268C19.7029 7.46289 19.9268 7.23903 19.9268 6.96289V5.96289C19.9268 5.68675 19.7029 5.46289 19.4268 5.46289H15.9268H15.4268H8.42676H7.92676ZM5.92676 8.46289H17.9268V20.9629C17.9268 21.239 17.7029 21.4629 17.4268 21.4629H6.42676C6.15062 21.4629 5.92676 21.239 5.92676 20.9629V8.46289Z" fill="#909090"/>
                        </svg>
                    </HintTooltip>
                </div>

            </FlexBox>
        </CategoryWrapper>
    )
}

const SortWithChildrens: FC<{ 
    parent?: Tag,
    items?: any[],
    onSortEnd?: (p: any, p2: any, p3: any) => void, 
    onClick: (ev: any, tag: Tag) => void,  
    parentTagId?: string, 
    visibleId?: string,
    currentId?: string,
    isTablet?: boolean
}> = ({
    parent,
    onSortEnd,
    onClick,
    parentTagId, 
    visibleId,
    currentId, 
    isTablet,
    items
}) => {
    const { t } = useTranslation();


    return (
        <SortableList 
            className="sortable-list" 
            as={'tbody'} 
            onSortEnd={(p1, p2) => onSortEnd && onSortEnd(p1,p2, parent)}
        >
            <DropDownWrapper show={parentTagId === visibleId}>
                {items?.map((p: any, index: number) => {
                    return (
                        <SortableItem key={"childrens-tab-sortable_" + index} data-tip={'children'}>
                            <CategoryWrapper 
                                onClick={(ev) => onClick(ev, p)} 
                                gx={16} 
                                justify="space-between"
                                align="center" 
                                data-id={p?.tagId} 
                                isChild={true} 
                            >
                                <FlexBox align={'center'} alignMobile="center">
                                    <SortableKnob>
                                            <div style={{ marginLeft: isTablet ? 24 : 48 , cursor: 'grab', backgroundColor: 'transparent' }}>
                                                <DottedIcon/>
                                            </div>
                                    </SortableKnob>
                                    <DroppableChildrenTitle 
                                        isChild={true}
                                        data-type={'location'}
                                        isEditTag={currentId === p?.tagId}
                                    >
                                        {p?.name}
                                    </DroppableChildrenTitle>
                                </FlexBox>

                                <FlexBox align="center" justify="flex-end" gx={40} direction="row">
                                    <div data-type={'remove'}>
                                        <HintTooltip data-type={'remove'} customStyle={{ background: '#fff', color: '#151514'}} textOffset={'-170px'} text={t("hints.delete_category")} z={6} noDisappearDelay onWhiteBg>
                                            <svg data-type={'remove'} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path data-type={'remove'} fillRule="evenodd" clipRule="evenodd" d="M9.42676 2.46289C8.59833 2.46289 7.92676 3.13446 7.92676 3.96289V4.46289H4.42676C3.59833 4.46289 2.92676 5.13446 2.92676 5.96289V6.96289C2.92676 7.79132 3.59833 8.46289 4.42676 8.46289H4.92676V20.9629C4.92676 21.7913 5.59833 22.4629 6.42676 22.4629H17.4268C18.2552 22.4629 18.9268 21.7913 18.9268 20.9629V8.46289H19.4268C20.2552 8.46289 20.9268 7.79132 20.9268 6.96289V5.96289C20.9268 5.13446 20.2552 4.46289 19.4268 4.46289H15.9268V3.96289C15.9268 3.13446 15.2552 2.46289 14.4268 2.46289H9.42676ZM14.9268 4.46289V3.96289C14.9268 3.68675 14.7029 3.46289 14.4268 3.46289H9.42676C9.15062 3.46289 8.92676 3.68675 8.92676 3.96289V4.46289H14.9268ZM7.92676 5.46289H4.42676C4.15062 5.46289 3.92676 5.68675 3.92676 5.96289V6.96289C3.92676 7.23903 4.15062 7.46289 4.42676 7.46289H4.92676H5.42676H18.4268H18.9268H19.4268C19.7029 7.46289 19.9268 7.23903 19.9268 6.96289V5.96289C19.9268 5.68675 19.7029 5.46289 19.4268 5.46289H15.9268H15.4268H8.42676H7.92676ZM5.92676 8.46289H17.9268V20.9629C17.9268 21.239 17.7029 21.4629 17.4268 21.4629H6.42676C6.15062 21.4629 5.92676 21.239 5.92676 20.9629V8.46289Z" fill="#909090"/>
                                            </svg>
                                        </HintTooltip>
                                    </div>
                                </FlexBox>
                            </CategoryWrapper>
                        </SortableItem>
                    )
                })}
            </DropDownWrapper>
        </SortableList>
    )
} 

export const DroppableItemContainer: FC<{ 
    tags: IConvertedTags[],
    onRemove: (tagId: string, type: string) => void,
    onClick: (tagId: string, flag?: boolean) => void,
    onSetScrollId?: (id: string) => void;
    onUpdatePositions: (categories: { id: string, subCategoryIds: string[]}[]) => void;
}> = ({ 
    tags,
    onRemove,
    onClick,
    onSetScrollId,
    onUpdatePositions, 
}) => {
    const isTablet = useIsMobile();
    const history = useHistory();
    const [data, setData] = useState<IConvertedTags[]>();
    const [time, setTime] = useState(Date.now());
    const [visibleId, setVisible] = useState<string | null>(null);
    const { 
        currentPlatform, 
    }  = useSelector(TagAdminSelector);

    const currentActiveTagId = useMemo(() => currentPlatform?.editCategory?.mainTag?.tagId , [currentPlatform])

    const onToggle = useCallback((id: string) => {
        if (visibleId === id) {
            setVisible(null)
            return;
        }
        setVisible(id)
    } , [visibleId])

    useEffect(() => {
        if(!!visibleId ) {
            onSetScrollId && onSetScrollId(visibleId)
        }
    }, [visibleId, onSetScrollId])

    const onParentsSortEnd = useCallback((oldIndex: number, newIndex: number) => {
        if (data?.length) {
            const newData = arrayMoveImmutable(data, oldIndex, newIndex)
            setData(newData);
            //@ts-ignore
            onUpdatePositions(newData?.reduce((acc, { parent, children }) => ([
                ...acc,
                { id: parent?.tagId, subCategoryIds: children?.map((child) => child?.tagId ) }
            ]) , []))
        }
      }, [data, onUpdatePositions]);

      const onChildrenSortEnd = useCallback((oldIndex: number, newIndex: number, parent?: any) => {
        const parentId = parent?.tagId;
        const newData = data;
        const parentIdx = data?.findIndex(({ parent }) => parent?.tagId === parentId);
        if (newData?.length) {
            const newOrder = arrayMoveImmutable(newData[parentIdx as number]?.children, oldIndex, newIndex)
            newData[parentIdx as number] = { ...newData[parentIdx as number], children: newOrder}
            setData(newData);
            setTime(Date.now());
            //@ts-ignore
            onUpdatePositions(newData?.reduce((acc, { parent, children }) => ([
                ...acc,
                { id: parent?.tagId, subCategoryIds: children?.map((child) => child?.tagId ) }
            ]) , []))
        }
      }, [data, onUpdatePositions]);

      const onItemClick = (ev: any, tag: Tag) => {
        const key = ev.target?.dataset['type'];
        if (key === 'location') {
            history.push(CreateLinkTo.tag(tag.tagId))
            return;
        } else if (key === 'dropdown') {
            onToggle && onToggle(tag?.tagId);
            return;
        } else if (key === 'remove') {
            onRemove && onRemove(tag?.tagId, TAG_ADMIN_OPERATION.remove);
            return
        }

        onClick && onClick(tag?.tagId, true)
    }

      useEffect(() => {
        if (tags?.length) {
            setData(tags)
        }
      } , [tags])

    return useMemo(() => (
        <SortableList className="sortable-list" as={'tbody'} onSortEnd={onParentsSortEnd}>    
            {data?.map(({ parent, hasChild, children }, idx) => {
                return (
                    <SortableItem key={"team-tab-sortable_" + idx} >
                        <FlexBox direction="column">
                            <DroppableItem
                                tag={parent} 
                                onClick={onItemClick}
                                isTablet={isTablet}
                                hasChild={hasChild}
                                isActive={visibleId === parent?.tagId}
                                isEditTag={currentActiveTagId === parent?.tagId}
                            />
            
                            {hasChild && <SortWithChildrens 
                                parent={parent}
                                onSortEnd={(p1, p2, tag) => onChildrenSortEnd(p1,p2, tag)}
                                items={children}
                                onClick={onItemClick}
                                currentId={currentActiveTagId}
                                parentTagId={parent?.tagId }
                                visibleId={visibleId ?? ''}
                                isTablet={isTablet}
                            />}
                        </FlexBox>
                    </SortableItem>
                )
            })}
        </SortableList>
    ) , [data, onClick, isTablet, time, visibleId, onToggle, onRemove, onChildrenSortEnd, onParentsSortEnd])
}import { Tag } from "@brg/api";
import { FlexBox, HintTooltip, useIsMobile } from "@brg/ui";
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import SortableList, { SortableItem, SortableKnob } from "react-easy-sort";
import { arrayMoveImmutable } from "shared/utils/arrayMove";
import { IConvertedTags } from "./DroppableCategoryList";
import { DropDownWrapper, DroppableChildrenTitle } from "./styles";
import { useSelector } from "react-redux";
import { TagAdminSelector } from "shared/reducers/tagAdminSlice";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CreateLinkTo } from "shared/constants/linkTo";
import { TAG_ADMIN_OPERATION } from "_deziiign/main/pages/MainTagAdminPage/MainTagAdminPage";
import { CategoryWrapper } from "../../styles";
import { DottedIcon } from "shared/icons/DottedIcon";

export const DroppableItem: FC<{ 
    tag: Tag<'Local'>, 
    isChild?: boolean,
    hasChild?: boolean,
    isActive?: boolean, 
    isTablet?: boolean,
    isEditTag?: boolean,
    onClick: (ev: any, tag: Tag) => void;
}> = ({ 
    tag, 
    isChild,
    hasChild,
    isActive,
    isTablet, 
    isEditTag,
    onClick,
}) => {
    const { t } = useTranslation();

    return (
        <CategoryWrapper 
            onClick={(ev: any) => onClick(ev, tag)} 
            gx={16} 
            justify="space-between"
            align="center" 
            data-id={tag?.tagId} 
            isChild={isChild} 
            isActive={isActive}
        >
            <FlexBox align={'center'} alignMobile="center">
                {isActive ? (
                    <HintTooltip customStyle={{ background: '#fff', color: '#151514'}} text={'Закройте категория для перетаскивания'} noDisappearDelay onWhiteBg>
                        <div style={{ marginLeft: isTablet ? (isChild ? 24 : 0) : (isChild ? 48 : 0) , backgroundColor: 'transparent' }}>
                            <DottedIcon/>
                        </div>
                    </HintTooltip>
                ) : (
                    <SortableKnob>
                        <div style={{ marginLeft: isTablet ? (isChild ? 24 : 0) : (isChild ? 48 : 0) , cursor: 'grab', backgroundColor: 'transparent' }}>
                            <DottedIcon/>
                        </div>
                    </SortableKnob>
                )}
                <DroppableChildrenTitle 
                    isChild={isChild}
                    data-type={'location'}
                    isEditTag={isEditTag}
                >
                    {tag?.name}
                </DroppableChildrenTitle>
            </FlexBox>

            <FlexBox align="center" justify="flex-end" gx={40} direction="row">
                {hasChild && (
                    <FlexBox data-type={'dropdown'}>
                        <svg data-type={'dropdown'} className={'shevron-icon'} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path data-type={'dropdown'} d="M12 9.90997L18.8882 17.0314C19.2341 17.389 19.7948 17.389 20.1406 17.0314C20.4865 16.6739 20.4865 16.0941 20.1406 15.7366L12.6262 7.96775C12.2804 7.6102 11.7197 7.6102 11.3738 7.96775L3.85941 15.7366C3.51357 16.0941 3.51356 16.6739 3.8594 17.0314C4.20524 17.389 4.76596 17.389 5.1118 17.0314L12 9.90997Z" fill="#909090"/>
                        </svg>
                    </FlexBox>
                )}
                <div data-type={'remove'}>
                    <HintTooltip data-type={'remove'} customStyle={{ background: '#fff', color: '#151514'}} textOffset={'-170px'} text={t("hints.delete_category")} z={6} noDisappearDelay onWhiteBg>
                        <svg data-type={'remove'} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path data-type={'remove'} fillRule="evenodd" clipRule="evenodd" d="M9.42676 2.46289C8.59833 2.46289 7.92676 3.13446 7.92676 3.96289V4.46289H4.42676C3.59833 4.46289 2.92676 5.13446 2.92676 5.96289V6.96289C2.92676 7.79132 3.59833 8.46289 4.42676 8.46289H4.92676V20.9629C4.92676 21.7913 5.59833 22.4629 6.42676 22.4629H17.4268C18.2552 22.4629 18.9268 21.7913 18.9268 20.9629V8.46289H19.4268C20.2552 8.46289 20.9268 7.79132 20.9268 6.96289V5.96289C20.9268 5.13446 20.2552 4.46289 19.4268 4.46289H15.9268V3.96289C15.9268 3.13446 15.2552 2.46289 14.4268 2.46289H9.42676ZM14.9268 4.46289V3.96289C14.9268 3.68675 14.7029 3.46289 14.4268 3.46289H9.42676C9.15062 3.46289 8.92676 3.68675 8.92676 3.96289V4.46289H14.9268ZM7.92676 5.46289H4.42676C4.15062 5.46289 3.92676 5.68675 3.92676 5.96289V6.96289C3.92676 7.23903 4.15062 7.46289 4.42676 7.46289H4.92676H5.42676H18.4268H18.9268H19.4268C19.7029 7.46289 19.9268 7.23903 19.9268 6.96289V5.96289C19.9268 5.68675 19.7029 5.46289 19.4268 5.46289H15.9268H15.4268H8.42676H7.92676ZM5.92676 8.46289H17.9268V20.9629C17.9268 21.239 17.7029 21.4629 17.4268 21.4629H6.42676C6.15062 21.4629 5.92676 21.239 5.92676 20.9629V8.46289Z" fill="#909090"/>
                        </svg>
                    </HintTooltip>
                </div>

            </FlexBox>
        </CategoryWrapper>
    )
}

const SortWithChildrens: FC<{ 
    parent?: Tag,
    items?: any[],
    onSortEnd?: (p: any, p2: any, p3: any) => void, 
    onClick: (ev: any, tag: Tag) => void,  
    parentTagId?: string, 
    visibleId?: string,
    currentId?: string,
    isTablet?: boolean
}> = ({
    parent,
    onSortEnd,
    onClick,
    parentTagId, 
    visibleId,
    currentId, 
    isTablet,
    items
}) => {
    const { t } = useTranslation();


    return (
        <SortableList 
            className="sortable-list" 
            as={'tbody'} 
            onSortEnd={(p1, p2) => onSortEnd && onSortEnd(p1,p2, parent)}
        >
            <DropDownWrapper show={parentTagId === visibleId}>
                {items?.map((p: any, index: number) => {
                    return (
                        <SortableItem key={"childrens-tab-sortable_" + index} data-tip={'children'}>
                            <CategoryWrapper 
                                onClick={(ev) => onClick(ev, p)} 
                                gx={16} 
                                justify="space-between"
                                align="center" 
                                data-id={p?.tagId} 
                                isChild={true} 
                            >
                                <FlexBox align={'center'} alignMobile="center">
                                    <SortableKnob>
                                            <div style={{ marginLeft: isTablet ? 24 : 48 , cursor: 'grab', backgroundColor: 'transparent' }}>
                                                <DottedIcon/>
                                            </div>
                                    </SortableKnob>
                                    <DroppableChildrenTitle 
                                        isChild={true}
                                        data-type={'location'}
                                        isEditTag={currentId === p?.tagId}
                                    >
                                        {p?.name}
                                    </DroppableChildrenTitle>
                                </FlexBox>

                                <FlexBox align="center" justify="flex-end" gx={40} direction="row">
                                    <div data-type={'remove'}>
                                        <HintTooltip data-type={'remove'} customStyle={{ background: '#fff', color: '#151514'}} textOffset={'-170px'} text={t("hints.delete_category")} z={6} noDisappearDelay onWhiteBg>
                                            <svg data-type={'remove'} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path data-type={'remove'} fillRule="evenodd" clipRule="evenodd" d="M9.42676 2.46289C8.59833 2.46289 7.92676 3.13446 7.92676 3.96289V4.46289H4.42676C3.59833 4.46289 2.92676 5.13446 2.92676 5.96289V6.96289C2.92676 7.79132 3.59833 8.46289 4.42676 8.46289H4.92676V20.9629C4.92676 21.7913 5.59833 22.4629 6.42676 22.4629H17.4268C18.2552 22.4629 18.9268 21.7913 18.9268 20.9629V8.46289H19.4268C20.2552 8.46289 20.9268 7.79132 20.9268 6.96289V5.96289C20.9268 5.13446 20.2552 4.46289 19.4268 4.46289H15.9268V3.96289C15.9268 3.13446 15.2552 2.46289 14.4268 2.46289H9.42676ZM14.9268 4.46289V3.96289C14.9268 3.68675 14.7029 3.46289 14.4268 3.46289H9.42676C9.15062 3.46289 8.92676 3.68675 8.92676 3.96289V4.46289H14.9268ZM7.92676 5.46289H4.42676C4.15062 5.46289 3.92676 5.68675 3.92676 5.96289V6.96289C3.92676 7.23903 4.15062 7.46289 4.42676 7.46289H4.92676H5.42676H18.4268H18.9268H19.4268C19.7029 7.46289 19.9268 7.23903 19.9268 6.96289V5.96289C19.9268 5.68675 19.7029 5.46289 19.4268 5.46289H15.9268H15.4268H8.42676H7.92676ZM5.92676 8.46289H17.9268V20.9629C17.9268 21.239 17.7029 21.4629 17.4268 21.4629H6.42676C6.15062 21.4629 5.92676 21.239 5.92676 20.9629V8.46289Z" fill="#909090"/>
                                            </svg>
                                        </HintTooltip>
                                    </div>
                                </FlexBox>
                            </CategoryWrapper>
                        </SortableItem>
                    )
                })}
            </DropDownWrapper>
        </SortableList>
    )
} 

export const DroppableItemContainer: FC<{ 
    tags: IConvertedTags[],
    onRemove: (tagId: string, type: string) => void,
    onClick: (tagId: string, flag?: boolean) => void,
    onSetScrollId?: (id: string) => void;
    onUpdatePositions: (categories: { id: string, subCategoryIds: string[]}[]) => void;
}> = ({ 
    tags,
    onRemove,
    onClick,
    onSetScrollId,
    onUpdatePositions, 
}) => {
    const isTablet = useIsMobile();
    const history = useHistory();
    const [data, setData] = useState<IConvertedTags[]>();
    const [time, setTime] = useState(Date.now());
    const [visibleId, setVisible] = useState<string | null>(null);
    const { 
        currentPlatform, 
    }  = useSelector(TagAdminSelector);

    const currentActiveTagId = useMemo(() => currentPlatform?.editCategory?.mainTag?.tagId , [currentPlatform])

    const onToggle = useCallback((id: string) => {
        if (visibleId === id) {
            setVisible(null)
            return;
        }
        setVisible(id)
    } , [visibleId])

    useEffect(() => {
        if(!!visibleId ) {
            onSetScrollId && onSetScrollId(visibleId)
        }
    }, [visibleId, onSetScrollId])

    const onParentsSortEnd = useCallback((oldIndex: number, newIndex: number) => {
        if (data?.length) {
            const newData = arrayMoveImmutable(data, oldIndex, newIndex)
            setData(newData);
            //@ts-ignore
            onUpdatePositions(newData?.reduce((acc, { parent, children }) => ([
                ...acc,
                { id: parent?.tagId, subCategoryIds: children?.map((child) => child?.tagId ) }
            ]) , []))
        }
      }, [data, onUpdatePositions]);

      const onChildrenSortEnd = useCallback((oldIndex: number, newIndex: number, parent?: any) => {
        const parentId = parent?.tagId;
        const newData = data;
        const parentIdx = data?.findIndex(({ parent }) => parent?.tagId === parentId);
        if (newData?.length) {
            const newOrder = arrayMoveImmutable(newData[parentIdx as number]?.children, oldIndex, newIndex)
            newData[parentIdx as number] = { ...newData[parentIdx as number], children: newOrder}
            setData(newData);
            setTime(Date.now());
            //@ts-ignore
            onUpdatePositions(newData?.reduce((acc, { parent, children }) => ([
                ...acc,
                { id: parent?.tagId, subCategoryIds: children?.map((child) => child?.tagId ) }
            ]) , []))
        }
      }, [data, onUpdatePositions]);

      const onItemClick = (ev: any, tag: Tag) => {
        const key = ev.target?.dataset['type'];
        if (key === 'location') {
            history.push(CreateLinkTo.tag(tag.tagId))
            return;
        } else if (key === 'dropdown') {
            onToggle && onToggle(tag?.tagId);
            return;
        } else if (key === 'remove') {
            onRemove && onRemove(tag?.tagId, TAG_ADMIN_OPERATION.remove);
            return
        }

        onClick && onClick(tag?.tagId, true)
    }

      useEffect(() => {
        if (tags?.length) {
            setData(tags)
        }
      } , [tags])

    return useMemo(() => (
        <SortableList className="sortable-list" as={'tbody'} onSortEnd={onParentsSortEnd}>    
            {data?.map(({ parent, hasChild, children }, idx) => {
                return (
                    <SortableItem key={"team-tab-sortable_" + idx} >
                        <FlexBox direction="column">
                            <DroppableItem
                                tag={parent} 
                                onClick={onItemClick}
                                isTablet={isTablet}
                                hasChild={hasChild}
                                isActive={visibleId === parent?.tagId}
                                isEditTag={currentActiveTagId === parent?.tagId}
                            />
            
                            {hasChild && <SortWithChildrens 
                                parent={parent}
                                onSortEnd={(p1, p2, tag) => onChildrenSortEnd(p1,p2, tag)}
                                items={children}
                                onClick={onItemClick}
                                currentId={currentActiveTagId}
                                parentTagId={parent?.tagId }
                                visibleId={visibleId ?? ''}
                                isTablet={isTablet}
                            />}
                        </FlexBox>
                    </SortableItem>
                )
            })}
        </SortableList>
    ) , [data, onClick, isTablet, time, visibleId, onToggle, onRemove, onChildrenSortEnd, onParentsSortEnd])
}